/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ct_Fiverr_LabelInputs */

const en_ct_fiverr_label = /** @type {(inputs: Ct_Fiverr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available on Fiverr`)
};

const ar_ct_fiverr_label = /** @type {(inputs: Ct_Fiverr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متاح على Fiverr`)
};

const bn_ct_fiverr_label = /** @type {(inputs: Ct_Fiverr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr-এ অ্যাভেইলেবল`)
};

const de_ct_fiverr_label = /** @type {(inputs: Ct_Fiverr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbar auf Fiverr`)
};

const es_ct_fiverr_label = /** @type {(inputs: Ct_Fiverr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible en Fiverr`)
};

const fr_ct_fiverr_label = /** @type {(inputs: Ct_Fiverr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible sur Fiverr`)
};

const pt_ct_fiverr_label = /** @type {(inputs: Ct_Fiverr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponível no Fiverr`)
};

const zh_ct_fiverr_label = /** @type {(inputs: Ct_Fiverr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可在 Fiverr 上使用`)
};

const tr_ct_fiverr_label = /** @type {(inputs: Ct_Fiverr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr'da mevcut`)
};

const ru_ct_fiverr_label = /** @type {(inputs: Ct_Fiverr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступно на Fiverr`)
};

const pl_ct_fiverr_label = /** @type {(inputs: Ct_Fiverr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostępne na Fiverr`)
};

/**
* | output |
* | --- |
* | "Available on Fiverr" |
*
* @param {Ct_Fiverr_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const ct_fiverr_label = /** @type {((inputs?: Ct_Fiverr_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ct_Fiverr_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ct_fiverr_label(inputs)
	if (locale === "bn") return bn_ct_fiverr_label(inputs)
	if (locale === "de") return de_ct_fiverr_label(inputs)
	if (locale === "es") return es_ct_fiverr_label(inputs)
	if (locale === "fr") return fr_ct_fiverr_label(inputs)
	if (locale === "pt") return pt_ct_fiverr_label(inputs)
	if (locale === "zh") return zh_ct_fiverr_label(inputs)
	if (locale === "tr") return tr_ct_fiverr_label(inputs)
	if (locale === "ru") return ru_ct_fiverr_label(inputs)
	if (locale === "pl") return pl_ct_fiverr_label(inputs)
	return en_ct_fiverr_label(inputs)
});